<div class="company-status-grid">
  <table class="status-col" *ngIf="companyStatusData">
    <tr>
      <td class="status-heading">Consensus Status</td>
      <td class="status-data">
        {{ companyStatusData.c_status ? companyStatusData.c_status : "NA" }}
      </td>
    </tr>
  </table>

  <table class="status-col border" *ngIf="companyStatusData">
    <tr>
      <td class="status-heading">Normalized Line Items</td>
      <td class="status-data">
        {{
          companyStatusData.normalized_line_items
            ? companyStatusData.normalized_line_items
            : "NA"
        }}
      </td>
    </tr>
    <tr>
      <td class="status-heading">Normalized Periods</td>
      <td class="status-data">
        {{
          companyStatusData.period_exists
            ? companyStatusData.from + " to " + companyStatusData.to
            : "NA"
        }}
      </td>
    </tr>
  </table>

  <table class="status-col border" *ngIf="companyStatusData">
    <tr>
      <td class="status-heading">Analysts in Consensus</td>
      <td class="status-data">
        {{
          companyStatusData.analysts_in_consensus
            ? companyStatusData.analysts_in_consensus
            : "NA"
        }}
      </td>
    </tr>
    <tr>
      <td class="status-heading">Analysts with Models</td>
      <td class="status-data">
        {{
          companyStatusData.analysts_in_models
            ? companyStatusData.analysts_in_models
            : "NA"
        }}
      </td>
    </tr>
  </table>

  <table class="status-col border" *ngIf="companyStatusData">
    <tr>
      <td class="status-heading">Last Reported Earnings</td>
      <td class="status-data">
        {{
          companyStatusData.last_earning ? companyStatusData.last_earning : "NA"
        }}
      </td>
    </tr>
    <tr>
      <td class="status-heading">
        Next Earnings
        <i>{{
          companyStatusData.event_type === "Tentative" ? "- Tentative" : ""
        }}</i>
        <va-icon
          size="small"
          name="info-circle"
          class="info-class"
          nz-tooltip
          [nzTooltipTitle]="
            earningsDataAccess === true
              ? 'Next earnings dates are provided by Factset and may not be up to date.'
              : 'You are not entitled to view this data'
          "
        ></va-icon>
      </td>
      <td class="status-data">
        {{
          companyStatusData.showNextEstimated
            ? companyStatusData.next_earning
            : "NA"
        }}
      </td>
      <td
        *ngIf="
          companyStatusData &&
          companyStatusData.earnings_preview &&
          companyStatusData.entitled_to_data
        "
        class="btn-holder"
      >
        <va-button
          btnType="text"
          size="small"
          [isOnlyIcon]="true"
          (click)="sendEarningsPreview()"
          nz-tooltip
          nzTooltipTitle="Open preview"
        >
          <va-icon size="small" name="eye" class="eye" ></va-icon>
        </va-button>
      </td>
    </tr>
  </table>
</div>
